// path : visuals/shared/node-visual.component.ts

import { Component, Input, OnInit } from '@angular/core';
import {Node} from './../../../models/index';

@Component({
  selector: '[nodeVisual]',
  templateUrl: './node-visual.component.html',
  styleUrls: ['./node-visual.component.css']
  
})
export class NodeVisualComponent {
  @Input('nodeVisual') node: Node;
}